import Page from '@admin/components/page'
import Overview from './overview'
import Payments from './payments'
import moment from 'moment'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: moment(resources.payout.date).format('YYYY-MM-DD'),
  manager: {
    path: `/admin/truevail/admin/payouts/${resources.payout.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview payout={ resources.payout } />
      },
      {
        label: 't(Payments)',
        path: '/payments',
        panel: <Payments payout={ resources.payout } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  payout: `/api/admin/truevail/admin/payouts/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
